<h2>{{ 'common.authentication.wait_for_authentication_text' | translate }}</h2>
